import api from "@/apiConfig/api";

export default {
  state() {
    return {
      branch_list: [],
      active_branch: null,
      active_branch_external_id: null,
    };
  },
  mutations: {
    setActiveBranchId(state, branch_id) {
      state.active_branch = branch_id;
    },
    setActiveBranchExternalId(state, external_id) {
      state.active_branch_external_id = external_id;
    },
  },
  actions: {
    async getBranches(context) {
      await api.get("/company").then((res) => {
        // Boundary guard: el-select v-for over branch_list renders through
        // Element Plus' internal dropdown; a non-array here throws
        // "undefined is not iterable (Symbol.iterator)" on every page that
        // mounts the header. Keep it an array no matter what /company returns.
        context.state.branch_list = Array.isArray(res.data) ? res.data : [];
      });
    },
  },
};
